import React from "react"
import Tags from "../partials/Tags"
import NewsArticle from "../partials/NewsArticle"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import AuthorAvatar from "../partials/AuthorAvatar"
//import { ElevenLabsAudioNative } from "./ElevenLabsAudioNative"
import {
  addScriptToHead,
  transformHtmlContent,
} from "../utils/transformHtmlContent"
import { splitFaqSections } from "../utils/faqSection"
import AuthorBlock from "./BlogList/AuthorBlock"
import { NoWrapHyphenatedWords } from "../partials/HeroHome"
import CtaBlog from "../partials/CtaBlog"
import FaqsInline from "../partials/FaqsInline"
import ShareButtons from "../partials/ShareButtons"

function BlogSingle({ data }) {
  //const [isHovered, setIsHovered] = useState(false)

  const post = data.ghostPost
  const feature_image = getImage(post.featureImage)

  post.html = transformHtmlContent(post.html, post.slug)

  // The FAQ accordion is interactive, so it can't ride along in the raw HTML
  // blob — the body is split around each faq_section and the block is mounted
  // as a real component at its authored position.
  const bodySegments = splitFaqSections(post.html)

  setTimeout(() => {
    addScriptToHead(post)
  }, 100)

  // Ghost Card scripts
  // https://ghost.org/docs/themes/content/
  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          <div className="max-w-3xl mx-auto">
            <article className="post">
              <header className="mb-8">
                {/* Title and excerpt */}
                <div className="text-center md:text-left">
                  <h1 className="h1 mb-4" data-aos="fade-up">
                    <NoWrapHyphenatedWords text={post.title} />
                  </h1>
                  <p
                    className="text-xl text-center md:text-left text-gray-400"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    {post.excerpt}
                  </p>

                  {/*<div
                    //className="fixed z-10 -bottom-10 -left-12 border-t-4 border-r-4 border-[#292d33] rounded-lg scale-75 overflow-hidden"
                    className="overflow-hidden mt-4"
                    // onMouseEnter={() => {
                    //   setIsHovered(false)
                    // }}
                    // onMouseLeave={() => {
                    //   setIsHovered(true)
                    // }}
                    style={{
                      //width: isHovered ? "114px" : "370px",
                      height: 89,
                      //background: "red",
                      //paddingLeft: isHovered ? "42.5px" : "0",
                    }}
                  >
                    <ElevenLabsAudioNative
                      publicUserId="11fa88f0bfb5e1f3bfd8c6b2098371f579e95c2f65c59a8edc2a0afbaa780832"
                      size="small"
                      //widthH={isHovered === true ? "120" : "370"}
                    />
                  </div>*/}
                </div>

                {/* Article meta */}
                <div className="md:flex md:items-center md:justify-between mt-4">
                  {/* Author meta */}
                  <div
                    className="flex items-center"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <AuthorAvatar {...{ data: post }} />
                  </div>
                  {/* Article tags */}
                  <div
                    className="flex justify-center mt-4 md:mt-0"
                    data-aos="fade-up"
                    data-aos-delay="600"
                  >
                    <Tags {...{ tags: post.tags }} />
                  </div>
                </div>
              </header>

              {/* Article image */}
              <figure
                className="mb-8 lg:-ml-32 lg:-mr-32"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                {post.feature_image ? (
                  <GatsbyImage
                    image={feature_image}
                    className="w-full"
                    alt={post.title}
                  />
                ) : null}
              </figure>

              {/* Article content */}
              <div className="text-lg text-gray-400 postBody">
                {bodySegments.map((segment, index) =>
                  segment.type === "faq" ? (
                    <FaqsInline key={index} items={segment.items} />
                  ) : (
                    <section
                      key={index}
                      dangerouslySetInnerHTML={{ __html: segment.value }}
                    />
                  ),
                )}
                <CtaBlog {...{ slug: post.slug }} />
              </div>

              {/* Article footer */}
              <footer>
                {/* Share buttons */}
                <ShareButtons {...{ post }} />

                {/* About author block */}
                <h4 className="h4 py-6 mb-2 mt-10 border-t border-gray-700 text-center md:text-left">
                  About author{post.authors.length > 1 && "s"}
                </h4>

                <AuthorBlock {...{ data }} />
              </footer>
            </article>
          </div>

          {/* Related articles */}
          <aside className="mt-20 border-t border-gray-700">
            <div className="max-w-sm mx-auto md:max-w-none">
              {/* Section title */}
              <h4 className="h4 py-6 mb-2 text-center md:text-left">
                More from blog
              </h4>

              {/* Articles container */}
              <div className="max-w-sm mx-auto md:max-w-none">
                <div className="grid gap-12 md:grid-cols-3 md:col-gap-6 md:row-gap-8 items-start">
                  {data &&
                    data.allGhostPost.edges.map(posts => (
                      <NewsArticle {...posts} key={posts.node.id} />
                    ))}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  )
}

export default BlogSingle
